@if (viewModel) {
    <div>
        <add-appeal-modal
            #AddAppealModal
            [appealLevels]="viewModel.stateAppealLevels"
            [assessments]="viewModel.annualYearModel.annualGridDetails"
            [selectedAnnualAssessmentId]="currentRevision?.annualAssessmentID"
            [topLevelCompanyId]="topLevelCompanyId"
            (addAppeal)="addAppeal($event)"
        >
        </add-appeal-modal>
        @if (viewModel.model.length === 0) {
            <div class="text-center">
                @if (currentYear && currentRevision) {
                    <div class="lead">
                        There are presently no appeals for {{ currentYear.annualYear1 }}
                        {{ currentRevision.revisionDesc }}.
                        @if (isStatusADate()) {
                            <div class="appeal-deadline">
                                Deadline of {{ currentRevision.appealStatus }} from the
                                <span
                                    class="anchor-style"
                                    (click)="assessmentNavigateHandler(currentYear, currentRevision)"
                                    >{{ currentRevision.revisionDesc }}</span
                                >
                                assessment.
                            </div>
                        }
                    </div>
                }
                @if (!currentYear || !currentRevision) {
                    <div class="lead"> There are presently no appeals for this year. </div>
                }
                @if (editState.hasWritePermission) {
                    <button class="ace-btn btn-primary" (click)="openAddAppeal()">New Appeal</button>
                }
            </div>
        }
        @if (viewModel.showTabs && editState.editMode) {
            <button
                type="button"
                (click)="openAddAppeal()"
                style="float: right; margin-top: 0.5em"
                class="ace-btn btn-primary btn-sm"
            >
                New Appeal
            </button>
        }
        <div [style.max-width]="editState.editMode ? '80%' : 'none'">
            @if (viewModel.model && viewModel.model.length > 0 && viewModel.showTabs) {
                <tabset #appealTabs>
                    @for (appeal of viewModel.model; track appeal; let i = $index; let last = $last) {
                        <tab
                            [heading]="appealHeading(i)"
                            [active]="i === viewModel.currentAppealIndex"
                            (selectTab)="switchTabs(i)"
                        >
                            <ng-container
                                [ngTemplateOutlet]="appealTemplate"
                                [ngTemplateOutletContext]="{ $implicit: appeal }"
                            ></ng-container>
                        </tab>
                    }
                </tabset>
            }
        </div>
        @if (viewModel.currentAppeal && !viewModel.showTabs) {
            <ng-container
                [ngTemplateOutlet]="appealTemplate"
                [ngTemplateOutletContext]="{ $implicit: viewModel.currentAppeal }"
            >
            </ng-container>
        }
    </div>
}

<ng-template #appealTemplate let-appeal>
    <div class="float-end">
        @if (appeal.hasInProgressIntakeItems && !isDocumentProcessing) {
            <entity-in-progress-indicator
                [entityId]="appeal.appealID"
                [entityTypeId]="appealEntityTypeId"
                [isDocumentProcessing]="isDocumentProcessing"
            >
            </entity-in-progress-indicator>
        }
        <entity-attachments
            [(hasAttachments)]="appeal.hasAttachments"
            buttonClass="has-icon"
            [modalData]="viewModel.attachmentModalData"
        >
        </entity-attachments>
        <entity-comments
            [(hasComments)]="appeal.hasComments"
            buttonClass="has-icon"
            [modalData]="viewModel.commentModalData"
            [disabled]="viewModel.loadingTaskSummary"
        >
        </entity-comments>
    </div>
    <table class="annual-appeal" (change)="setDirty()">
        <tr>
            <td>Appeal Level:</td>
            <td>
                @if (!editState.editMode || hasLitigationReferral(appeal)) {
                    <span>{{ viewModel.appealLevelAbbrDisplay(appeal.appealLevelID) }}</span>
                }
                @if (editState.editMode && !hasLitigationReferral(appeal)) {
                    <select
                        [(ngModel)]="appeal.appealLevelID"
                        class="form-select form-select-sm"
                        (ngModelChange)="changeAppealLevelObj($event, appeal)"
                    >
                        <!--ng-change="changeAppealLevelObj(appeal)"-->
                        @for (level of viewModel.stateAppealLevels; track level) {
                            <option [ngValue]="level.appealLevelID">{{ level.abbr }}</option>
                        }
                    </select>
                }
            </td>
        </tr>
        <tr>
            <td>Litigation:</td>
            <td>
                <span>{{ viewModel.appealLevelLitigationDisplay(appeal.appealLevelID) }}</span>
            </td>
        </tr>
        <tr>
            <td>Revision Appealed:</td>
            <td>
                @if (!editState.editMode) {
                    <span>{{ getAssessmentDescription(appeal.annualAssessmentID) }}</span>
                }
                @if (editState.editMode) {
                    <select
                        [(ngModel)]="appeal.annualAssessmentID"
                        class="form-select form-select-sm"
                        (ngModelChange)="setSavings(appeal)"
                    >
                        @for (assessment of viewModel.annualYearModel.annualGridDetails; track assessment) {
                            <option [ngValue]="assessment.annualAssessmentID">{{ assessment.revisionDesc }} </option>
                        }
                    </select>
                }
            </td>
        </tr>
        <tr>
            <td>Filing Reference:</td>
            <td>
                @if (!editState.editMode) {
                    <span>{{ appeal.filingReference }}</span>
                }
                @if (editState.editMode) {
                    <input class="form-control" [(ngModel)]="appeal.filingReference" maxlength="50" />
                }
            </td>
        </tr>
        <tr>
            <td>Case #:</td>
            <td>
                @if (!editState.editMode) {
                    <span>{{ appeal.caseNumber }}</span>
                }
                @if (editState.editMode) {
                    <input class="form-control" maxlength="35" [(ngModel)]="appeal.caseNumber" />
                }
            </td>
        </tr>
        <tr>
            <td>Hearing Location:</td>
            <td>
                @if (!editState.editMode) {
                    <span>{{ appeal.hearingLocation }}</span>
                }
                @if (editState.editMode) {
                    <input class="form-control" maxlength="50" [(ngModel)]="appeal.hearingLocation" />
                }
            </td>
        </tr>
        <tr>
            <td>File By Date:</td>
            <td class="hearing-date">
                <div class="input-group" style="display: inline-block">
                    <weissman-datetime
                        [(inputDate)]="appeal.fileByDate"
                        [readOnly]="!editState.editMode"
                        [dateOnly]="true"
                        (change)="onTaskRelevantFieldChanged()"
                        #fileByDate
                    >
                    </weissman-datetime>
                </div>
            </td>
        </tr>
        @if (showSubmitEvidence() || appeal.isFromAcquisition) {
            <tr>
                <td>Submit Evidence Date:</td>
                <td class="hearing-date">
                    <div class="input-group" style="display: inline-block">
                        <weissman-datetime
                            [(inputDate)]="appeal.submitEvidenceDateTimeLocal"
                            [readOnly]="!editState.editMode"
                            (validationChange)="onSubmitEvidenceValidationChange($event)"
                            (change)="onTaskRelevantFieldChanged()"
                            #submitEvidenceDateTimeLocal
                        >
                        </weissman-datetime>
                    </div>
                    <div style="display: inline-block">
                        @if (showBrokenChain(appeal.submitEvidenceDateTimeLocal)) {
                            <i
                                class="fa fa-chain-broken"
                                style="margin-left: 6px; position: absolute; margin-top: -22px"
                                aria-hidden="true"
                            ></i>
                        }
                    </div>
                </td>
            </tr>
        }
        @if (showConfirmHearing() || appeal.isFromAcquisition) {
            <tr>
                <td>Confirm Hearing Date:</td>
                <td class="hearing-date">
                    <div class="input-group" style="display: inline-block">
                        <weissman-datetime
                            [(inputDate)]="appeal.confirmHearingDate"
                            [readOnly]="!editState.editMode"
                            [dateOnly]="true"
                            (change)="onTaskRelevantFieldChanged()"
                            #confirmHearingDate
                        >
                        </weissman-datetime>
                    </div>
                </td>
            </tr>
        }
        @if (showInformalHearing() || appeal.isFromAcquisition) {
            <tr>
                <td>Informal Hearing Date:</td>
                <td class="hearing-date">
                    <div class="input-group" style="display: inline-block">
                        <weissman-datetime
                            [(inputDate)]="appeal.informalHearingDateTimeLocal"
                            [readOnly]="!editState.editMode"
                            (validationChange)="onInformalHearingValidationChange($event)"
                            (change)="onTaskRelevantFieldChanged()"
                            #informalHearingDateTimeLocal
                        >
                        </weissman-datetime>
                    </div>
                    <div style="display: inline-block">
                        @if (showBrokenChain(appeal.informalHearingDateTimeLocal)) {
                            <i
                                class="fa fa-chain-broken"
                                style="margin-left: 6px; position: absolute; margin-top: -22px"
                                aria-hidden="true"
                            ></i>
                        }
                    </div>
                </td>
            </tr>
        }
        @if (showHearing() || appeal.isFromAcquisition) {
            <tr>
                <td>Formal Hearing Date:</td>
                <td class="hearing-date">
                    <div class="input-group" style="display: inline-block">
                        <weissman-datetime
                            [(inputDate)]="appeal.hearingDateTimeLocal"
                            [readOnly]="!editState.editMode"
                            (validationChange)="onHearingValidationChange($event)"
                            (change)="onTaskRelevantFieldChanged()"
                            #hearingDateTimeLocal
                        >
                        </weissman-datetime>
                    </div>
                    <div style="display: inline-block">
                        @if (showBrokenChain(appeal.hearingDateTimeLocal)) {
                            <i
                                class="fa fa-chain-broken"
                                style="margin-left: 6px; position: absolute; margin-top: -22px"
                                aria-hidden="true"
                            ></i>
                        }
                    </div>
                </td>
            </tr>
        }
        @if (!viewModel.loadingTaskSummary && viewModel.currentTaskSummary) {
            <tr>
                <td style="vertical-align: top">Status:</td>
                @if (viewModel.currentTaskSummary.Status && !viewModel.loadingTaskSummary) {
                    <td>
                        <div style="margin-bottom: 6px; font-size: 14px">
                            <i
                                class="fa fa-check"
                                [hidden]="
                                    !viewModel.currentTaskSummary || !viewModel.currentTaskSummary.SeriesIsComplete
                                "
                                style="color: green; float: left; font-size: 16px"
                            ></i>
                            <span
                                class="anchor-style"
                                (click)="launchTaskModal(appeal)"
                                tooltip="{{ this.editState.validationMessage }}"
                                placement="left"
                                triggers="click focus"
                                #appealTaskValidation="bs-tooltip"
                            >
                                {{ viewModel.currentTaskSummary.Status }}
                                @if (viewModel.currentTaskSummary.CompletedDateTime) {
                                    <span>
                                        {{
                                            viewModel.currentTaskSummary.CompletedDateTime
                                                | weissmanDateFormat: true : 'Central'
                                        }}
                                    </span>
                                }
                            </span>
                        </div>
                        @if (canPrepareApplication(appeal)) {
                            <div>
                                <a style="cursor: pointer" (click)="navigateToAppealApplication(appeal)"
                                    >Edit Application</a
                                >
                            </div>
                        }
                    </td>
                }
            </tr>
        }
        @if (!viewModel.currentTaskSummary && !viewModel.loadingTaskSummary) {
            <tr>
                <td>Status:</td>
                @if (!viewModel.currentTaskSummary && !viewModel.loadingTaskSummary) {
                    <td>
                        <div style="margin-bottom: 6px; font-size: 14px"> N/A - No Responsibility </div>
                    </td>
                }
            </tr>
        }
        <tr>
            <td>Resolution:</td>
            <td>
                @if (!editState.editMode) {
                    <span>{{ getAppealStatus(appeal) }}</span>
                }
                @if (editState.editMode) {
                    <select
                        class="form-select form-select-sm"
                        [ngModel]="appeal.appealStatusID"
                        (ngModelChange)="appealStatusChanged(appeal, $event)"
                    >
                        @for (status of appealStatuses; track status) {
                            <option [ngValue]="status.appealStatusID">{{ status.status }}</option>
                        }
                    </select>
                }
            </td>
        </tr>
        @if (isClosed(appeal)) {
            <tr>
                <td>Outcome Revision:</td>
                <td>
                    @if (!editState.editMode) {
                        <span>{{ getAppealOutcomeRevision(appeal) }}</span>
                    }
                    @if (editState.editMode) {
                        <select
                            class="form-select form-select-sm"
                            [(ngModel)]="appeal.outcomeAnnualAssessmentID"
                            (ngModelChange)="appealOutcomeRevisionChanged(appeal)"
                        >
                            <option [ngValue]="null"></option>
                            @for (revision of viewModel.annualYearModel.annualGridDetails; track revision) {
                                <option [ngValue]="revision.annualAssessmentID">{{ revision.revisionDesc }}</option>
                            }
                        </select>
                    }
                </td>
            </tr>
        }
        @if (showAnticipatedFMV(appeal)) {
            <tr>
                <td>
                    @if (enableTrueTaxRate) {
                        <span>Anticipated MV:</span>
                    }
                    @if (!enableTrueTaxRate) {
                        <span>Anticipated FMV:</span>
                    }
                </td>
                <td>
                    @if (!editState.editMode) {
                        <span>{{ appeal.anticipatedFMV | number: '1.0-0' }}</span>
                    }
                    @if (editState.editMode) {
                        <input
                            class="form-control input-number"
                            [(ngModel)]="appeal.anticipatedFMV"
                            (ngModelChange)="setDirty()"
                            (blur)="calculateSavings(appeal)"
                            currencyMask
                            [options]="{ allowNegative: false, precision: 0, prefix: '' }"
                        />
                    }
                </td>
            </tr>
        }
        <tr>
            <td>Savings:</td>
            <td class="savings">
                @if (!editState.editMode && hasDisplayableSavings(appeal)) {
                    <span [ngClass]="{ overridden: appeal.savingsOverridden, estimated: !isClosed(appeal) }">{{
                        appeal.savings | currency: 'USD'
                    }}</span>
                    @if (enableTrueTaxRate) {
                        <i
                            class="fa fa-info-circle"
                            style="margin-left: 5px"
                            helpTooltip
                            (click)="getDetailedSavingsCalculationInfo(appeal)"
                            tooltipText="Click for details"
                        >
                        </i>
                    }
                }
                @if (editState.editMode) {
                    <div class="mb-3 has-feedback" style="margin-bottom: 0">
                        <input
                            class="form-control input-number"
                            style="padding-right: 10px; display: inline-block"
                            [ngClass]="{ overridden: appeal.savingsOverridden, estimated: !isClosed(appeal) }"
                            [(ngModel)]="appeal.savings"
                            (ngModelChange)="savingsChanged(appeal)"
                            currencyMask
                            [options]="{ allowNegative: false, precision: 2 }"
                        />
                        @if (isCalculatingSavings) {
                            <i class="fa fa-spinner fa-pulse form-control-feedback"></i>
                        }
                        @if (appeal.savingsOverridden) {
                            <button
                                class="ace-btn has-icon btn-sm btn-primary btn-danger ms-1"
                                (click)="revertToOriginalSavings(appeal)"
                                style="margin: 0"
                            >
                                <i class="fa fa-undo"></i>
                            </button>
                        }
                    </div>
                }
            </td>
        </tr>
        @if (isClosed(appeal)) {
            <tr>
                <td>Savings Date:</td>
                <td class="hearing-date">
                    <div class="input-group" style="display: inline-block">
                        <weissman-datetime
                            [(inputDate)]="appeal.savingsDate"
                            [readOnly]="!editState.editMode"
                            [dateOnly]="true"
                            (change)="onTaskRelevantFieldChanged()"
                            #savingsDate
                        >
                        </weissman-datetime>
                    </div>
                </td>
            </tr>
        }
        @if (hasRyanPrivateView && isRyanInstance) {
            <tr>
                <td>Non-Ryan:</td>
                <td>
                    <input
                        type="checkbox"
                        [disabled]="!(hasRyanPrivateEdit && editState.editMode)"
                        [(ngModel)]="appeal.isNonRyan"
                    />
                </td>
            </tr>
        }
        @if (hasRyanPrivateView && isRyanInstance) {
            <tr>
                <td>RLS:</td>
                <td>
                    <div class="checkbox">
                        <label>
                            <input
                                type="checkbox"
                                [disabled]="
                                    !(hasRyanPrivateEdit && editState.editMode && !hasLitigationReferral(appeal))
                                "
                                [(ngModel)]="appeal.isRyanLegalServices"
                            />
                            @if (hasLitigationReferral(appeal)) {
                                <a class="pointer" (click)="openLitigationReferral(appeal)">
                                    Litigation Referral: {{ appeal.belongsToLitigationReferralMatterId }}
                                </a>
                            }
                        </label>
                    </div>
                </td>
            </tr>
        }
    </table>
    @if (!hideDelete && editState.editMode) {
        <button class="ace-btn btn-sm btn-primary btn-danger" type="button" (click)="deleteAppeal(appeal)"
            >Delete
        </button>
    }
</ng-template>
